import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import NodalCashFlowPageUI from './NodalCashFlowPageUI.js'

class NodalCashFlowPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      climeTypeInflowList: null,
      climeTypeOutflowList: null,
      txnTypeInflowList: null,
      txnTypeOutflowList: null,
      errorList: null,
      //
      downloadMode: false,
      downloadCFMode: false,
      //
      startDate: '',
      endDate: '',
      submitted: false,
    }
  }

  render() {
    return (
      <NodalCashFlowPageUI
        context={this.props.context}
        errorList={this.state.errorList}
        accountNumber={this.props.match.params.accountNumber}
        // txn
        cashFlow={this.state.cashFlow}
        climeTypeInflowList={this.state.climeTypeInflowList}
        climeTypeOutflowList={this.state.climeTypeOutflowList}
        txnTypeInflowList={this.state.txnTypeInflowList}
        txnTypeOutflowList={this.state.txnTypeOutflowList}
        onRefreshClick={this.onRefreshClick}
        //
        downloadMode={this.state.downloadMode}
        onDownloadClick={() => { this.setState({ downloadMode: true }) }}
        onDownloadCancel={() => { this.setState({ downloadMode: false }) }}
        //
        downloadCFMode={this.state.downloadCFMode}
        onDownloadCFClick={() => { this.setState({ downloadCFMode: true }) }}
        onDownloadCFCancel={() => { this.setState({ downloadCFMode: false }) }}
        //
        startDate={this.state.startDate}
        endDate={this.state.endDate}
        onStartDateChange={this.onStartDateChange}
        onEndDateChange={this.onEndDateChange}
        onSubmit={this.onSubmit}
      />
    )
  }

  onStartDateChange = (startDate) => {
    this.setState({ startDate: startDate })
    let filter = { startDate: startDate, endDate: this.state.endDate}
    sessionStorage.setItem(CacheKeys.NodalCFDateRange(), JSON.stringify(filter))
  }

  onEndDateChange = (endDate) => {
    this.setState({ endDate: endDate })
    let filter = { startDate: this.state.startDate, endDate: endDate}
    sessionStorage.setItem(CacheKeys.NodalCFDateRange(), JSON.stringify(filter))
  }

  componentDidMount() {
    let context = this.props.context
    let filtersStr = sessionStorage.getItem(CacheKeys.NodalCFDateRange())
    let filter = filtersStr ? JSON.parse(filtersStr) : {}
    this.setState({startDate: filter.startDate, endDate: filter.endDate})
    if (filter.startDate && filter.endDate)
      this.getNodalCashFlow(context, this.props.match.params.accountNumber, filter.startDate, filter.endDate)
  }

  componentDidUpdate(prevProps) {
    let context = this.props.context
    if (this.props.match.params.accountNumber === prevProps.match.params.accountNumber)
      return
    this.getNodalCashFlow(context, this.props.match.params.accountNumber, this.state.startDate, this.state.endDate)
  }

  getNodalCashFlow(context, accountNumber, startDate, endDate) {
    let cacheManager = new CacheManager({
      resource: `/api/su/nodalBankAccounts/${accountNumber}/cashFlows`,
      cacheKey: CacheKeys.NodalCashFlow(accountNumber, startDate, endDate),
      callback: this.getNodalCashFlowCallback,
      ttlInSecs: 3600
    })
    console.log(startDate, endDate);
    cacheManager.getObject2(context, {}, { startDate: startDate, endDate: endDate })
  }

  getNodalCashFlowCallback = (response) => {
    this.setState({
      cashFlow: response,
      climeTypeInflowList: response.climeTypeInflowList,
      climeTypeOutflowList: response.climeTypeOutflowList,
      txnTypeInflowList: response.txnTypeInflowList,
      txnTypeOutflowList: response.txnTypeOutflowList,
      startDate: response.startDateISO,
      endDate: response.endDateISO,
      submitted: false
    })
  }

  onSubmit = () => {
    if (!this.state.startDate || !this.state.endDate) {
      return
    }
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    this.getNodalCashFlow(this.props.context, this.props.match.params.accountNumber, this.state.startDate, this.state.endDate)
  }

  onRefreshClick = () => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.NodalCashFlow(this.props.match.params.accountNumber, this.state.startDate, this.state.endDate))
    this.setState({
      climeTypeInflowList: null,
      climeTypeOutflowList: null,
      txnTypeInflowList: null,
      txnTypeOutflowList: null,
    },
      this.getNodalCashFlow(context, this.props.match.params.accountNumber, this.state.startDate, this.state.endDate)
    )
  }
}

export default withRouter(NodalCashFlowPageSF)
